import { Injectable } from "@angular/core";
import { SearchRequest, SearchRequestCriteria } from "../models/searchRequest";
import { SearchRequestHistoryItem } from "../models/searchRequestHistoryItem";
import { LocalStorageService } from "./localstorage.service";

@Injectable({
  providedIn: "root",
})
export class SearchHistoryService {
  private maximumSearchesToKeep: number = 20;
  storagekey: string = "yara_tankmix_" + "public_site_search_history";
  lastSearchResultsStoragekey: string =
    "yara_tankmix_" + "public_site_last_search_results_";
  constructor(private storage: LocalStorageService) {}
  private getHistoryArray(): SearchRequestHistoryItem[] {
    let array: SearchRequestHistoryItem[] | undefined = this.storage.retrieve(
      this.storagekey
    );

    if (array == undefined) array = [];
    return array;
  }

  storeSearchCritera(
    historyItem: SearchRequestCriteria,
    resultsReturned?: number,
    kind?: string
  ) {
    let array = this.getHistoryArray();
    array.push({
      at: new Date(),
      criteria: historyItem,
      resultsReturned: resultsReturned,
      kind,
    });
    if (array.length > this.maximumSearchesToKeep) array = array.splice(0, 1);
    this.storage.store(this.storagekey, array);
  }

  listSearchHistory(): SearchRequestHistoryItem[] {
    return this.getHistoryArray();
  }

  getHistoryItem(index: number): SearchRequestHistoryItem {
    var array = this.getHistoryArray();
    return array[index];
  }
  getAllHistoryItems(): SearchRequestHistoryItem[] {
    var array = this.getHistoryArray();
    return array.sort();
  }

  clearHistory() {
    this.storage.remove(this.storagekey);
  }
  storeSearchResults(results: any, kind?: string) {
    this.storage.store(this.lastSearchResultsStoragekey + kind, results);
  }
  retrieveSearchResults(kind?: string) {
    return this.storage.retrieve(this.lastSearchResultsStoragekey + kind);
  }

  clearSearchResults(kind?: string) {
    return this.storage.remove(this.lastSearchResultsStoragekey + kind);
  }
}
